var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFaqs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2898_1000",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H20V20H2V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2898_1000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99219 15.2172C9.47369 17.6435 11.6139 19.4727 14.1816 19.4727C15.2433 19.4727 16.2317 19.1597 17.0603 18.6214L19.2183 19.2183L18.6214 17.0603C19.1597 16.2318 19.4726 15.2433 19.4726 14.1816C19.4726 11.6139 17.6435 9.47373 15.2172 8.99223",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87305 2.52734C5.36843 2.52734 2.52734 5.36843 2.52734 8.87305C2.52734 10.1295 2.89258 11.3006 3.52251 12.2861L2.7817 14.9644L5.46004 14.2236C6.44558 14.8535 7.61663 15.2188 8.87305 15.2188C12.3777 15.2188 15.2188 12.3777 15.2188 8.87305C15.2188 5.36843 12.3777 2.52734 8.87305 2.52734Z",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40039 12.582H8.3457V11.5273H9.40039V12.582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.29102 7.27344C7.29102 6.3997 7.99931 5.69141 8.87305 5.69141C9.74679 5.69141 10.4551 6.3997 10.4551 7.27344C10.4551 7.73574 10.2567 8.15168 9.9405 8.44091L8.87305 9.41797V10.4727",
    stroke: "white",
    strokeWidth: 1.05469,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqs);
export default __webpack_public_path__ + "static/media/iconFaqs.d52df4bf6bc70cf8966f951ef7e9d5c5.svg";
export { ForwardRef as ReactComponent };